// extracted by mini-css-extract-plugin
export default {"loader":"loadingSpinner_loader__mofVC","rotation":"loadingSpinner_rotation__W9KZ1"};